import React from 'react'
import PropTypes from 'prop-types'

import {
  FirstPaintGate,
  useIntl,
} from '@termly-web/common'

import ConsentConfigProvider from 'components/ConsentConfigProvider'
import DisplayManager from 'components/DisplayManager'
import GACMProvider from 'components/GACMProvider'
import GVLProvider from 'components/GVLProvider'
import LocationProvider from 'components/LocationProvider'
import TCFProvider from 'components/TCFProvider'
import ThemeProvider from 'components/ThemeProvider'
import WebsiteProvider from 'components/WebsiteProvider'


export default function LocalizedAppContent({ children, consentConfig, countryCode, website }) {
  const { locale } = useIntl()

  // The gate sits below the two providers that fetch, and above
  // everything that renders. GVLProvider renders nothing at all until the
  // vendor list arrives, so gating it would put that request in series
  // behind the wait for the translations rather than alongside it, and a
  // TCF banner would pay for both waits one after the other. Nothing
  // above the gate puts anything in the document, so waiting still costs
  // the visitor a blank frame and nothing more.
  return (
    <ConsentConfigProvider
      consentConfig={ consentConfig }
    >
      <GVLProvider
        lang={ locale }
        websiteUUID={ website.uuid }
      >
        <GACMProvider
          websiteUUID={ website.uuid }
        >
          <FirstPaintGate>
            <TCFProvider
              lang={ locale }
              websiteUUID={ website.uuid }
            >
              <WebsiteProvider
                website={ website }
              >
                <LocationProvider
                  countryCode={ countryCode }
                >
                  <ThemeProvider>
                    <DisplayManager>
                      { children }
                    </DisplayManager>
                  </ThemeProvider>
                </LocationProvider>
              </WebsiteProvider>
            </TCFProvider>
          </FirstPaintGate>
        </GACMProvider>
      </GVLProvider>
    </ConsentConfigProvider>
  )
}

LocalizedAppContent.propTypes = {
  children: PropTypes.node,
  consentConfig: ConsentConfigProvider.propTypes.consentConfig,
  countryCode: LocationProvider.propTypes.countryCode,
  website: WebsiteProvider.propTypes.website,
}
